import React, { useEffect, useRef, useState } from "react";
import { HeaderMenu } from "../../common/ui-kit/headers/HeaderMenu";
// import { Indicator } from '../../common/ui-kit/Indicator';
import { IndicatorEnum } from "../../common/types/IndicatorEnum";
import {
  DietaryOption,
  DishInMenuType,
  DishType,
} from "../../common/types/ResponseType";
import styles from "./MenuPage.module.scss";
import { Indicator } from "../../common/ui-kit/Indicator";
import { useNavigate, useParams } from "react-router-dom";
import menuResponse from "../menuResponse.json";
import { Notification } from "../../common/ui-kit/Notification/Notification";
import { vw } from "../../utils/tool/vw";
import { $white } from "../../common/constants/style";
import Filter from "../../assets/icons/filter.svg";
import Chevron from "../../assets/icons/chevron.svg";
import { useAppDispatch, useAppSelector } from "../../utils/hook/redux-hooks";
import { fetchMenu } from "../../store/redux/menuSlice";
import { FilterModal } from "../../common/ui-kit/Modal/FilterModal";
import { Loader } from "../../common/ui-kit/Loader/Loader";
import { formatPrice } from "../../utils/tool/format";
import Analytics from "../../analytics/Analytics";
import {RecommendedBadge} from "../../common/ui-kit/RecommendedBadge";
import {TopChoiceBadge} from "../../common/ui-kit/TopChoiceBadge";
import { QuantityControl } from "../../common/ui-kit/Cart/QuantityControl";
import { useCart } from "../../utils/hook/useCart";
import { useOrderingEnabled } from "../../utils/hook/useOrderingEnabled";
import { localizeDish } from "../../utils/localization/apply";
import { useUiString } from "../../utils/hook/useUiString";

type CategoryDishesType = Record<string, string[]>;
type CategorizedDishes = {
  [category: string]: DishInMenuType[];
};
interface MenuPageProps {
  updateMenuId: (menuId: string | null) => void;
}

export const MenuPage: React.FC<MenuPageProps> = ({ updateMenuId }) => {
  // const [menu, setMenu] = React.useState<any>(menuResponse);
  const [originalMenu, setOriginalMenu] = useState<any>(menuResponse);
  const [modalVisible, setModalVisible] = useState(false);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { menu, activeDietaries, activeCategory, loading, categoryLoading, locale } =
    useAppSelector((state) => state.menu);
  const [isDishClicked, setIsDishClicked] = useState<boolean>(() => {
    const storedValue = localStorage.getItem("isDishClicked");
    return storedValue ? JSON.parse(storedValue) : false;
  });

  const { attachMenu } = useCart();
  const orderingEnabled = useOrderingEnabled();
  const t = useUiString();

  const startTimeRef = useRef<number>(Date.now());

  const [categorizedDishes, setCategorizedDishes] = useState<CategorizedDishes>(
    {}
  );
  // const [pastaDish, setPastaDish] = useState<any | null>(null);
  // const [antipastaDish, setAntipastaDish] = useState<any | null>(null);
  // const [pizzaDish, setPizzaDish] = useState<any | null>(null);
  // const [insalataDish, setInsalataDish] = useState<any | null>(null);
  // const [entreeDish, setEntreeDish] = useState<any | null>(null);

  // const categoryDishes: CategoryDishesType = {
  //     Antipasta: [
  //         'Eggplant Rollitoni',
  //         'Chicken Montadito',
  //         'Pull Apart Bread',
  //         'Henny Wings',
  //         'Baked Clams Oreganta',
  //     ],
  //     Pizza: ['Dominican Pizza', 'Primavera Pizza'],
  //     Pasta: [
  //         'Penne Alla Vodka',
  //         'Rigatoni Bologne',
  //         'Cheese Ravioli',
  //         'Rigatoni Marsala',
  //         'Lasagna',
  //     ],
  //     New: [
  //         'Penne Alla Vodka',
  //         'Rigatoni Bologne',
  //         'Cheese Ravioli',
  //         'Rigatoni Marsala',
  //         'Lasagna',
  //     ],
  //     Insalata: ['Caprese Salad'],
  //     Entree: ['Il Sole Mofongo', 'Churrasco'],
  // };
  //
  // useEffect(() => {
  //     if (activeCategory in categoryDishes) {
  //         const dishes = menu?.dishes.filter(dish =>
  //             // @ts-ignore
  //             categoryDishes[activeCategory].includes(dish.name)
  //         );
  //         switch (activeCategory) {
  //             case 'Antipasta':
  //                 setAntipastaDish(dishes);
  //                 break;
  //             case 'Pizza':
  //                 setPizzaDish(dishes);
  //                 break;
  //             case 'Pasta':
  //             case 'New':
  //                 setPastaDish(dishes);
  //                 break;
  //             case 'Insalata':
  //                 setInsalataDish(dishes);
  //                 break;
  //             case 'Entree':
  //                 setEntreeDish(dishes);
  //                 break;
  //             default:
  //                 // Handle any default or unexpected category cases
  //                 break;
  //         }
  //     }
  // }, [activeCategory, menu]);

  useEffect(() => {
    if (id) {
      updateMenuId(id.toString());
      attachMenu(Number(id));
      dispatch(fetchMenu({ id: Number(id) }));
    } else {
      // navigate.navigate(ScreenEnum.SCANNER);
    }
  }, [id, dispatch, updateMenuId, attachMenu]);

  const handleClickCard = (dishId: number) => {
    setIsDishClicked(true);
    localStorage.setItem("isDishClicked", JSON.stringify(true));
    navigate(`/menu/${id}/dish/${dishId}`);
  };

  useEffect(() => {
    if (menu?.dishes) {
      const categories = {};

      menu.dishes.forEach((dish) => {
        if (dish.category && dish.category.name) {
          const category = dish.category.name;
          // @ts-ignore
          if (!categories[category]) {
            // @ts-ignore
            categories[category] = [];
          }
          // @ts-ignore
          categories[category].push(dish);
        }
      });

      // Sort dishes within each category: top-choice first, then recommended
      Object.keys(categories).forEach((category) => {
        // @ts-ignore
        categories[category].sort((a: DishInMenuType, b: DishInMenuType) => {
          const aPriority = a.isTopChoice === true ? 2 : (a.isRecommended === true ? 1 : 0);
          const bPriority = b.isTopChoice === true ? 2 : (b.isRecommended === true ? 1 : 0);
          return bPriority - aPriority; // Higher priority first
        });
      });

      setCategorizedDishes(categories);
    }
  }, [menu]);

  // const getFilteredDishes = () => {
  //     if (!menu || !menu.dishes) {
  //         return [];
  //     }
  //     try {
  //         return menu.dishes.filter((dish) => {
  //             const categoryMatch = dish.categories.includes(activeCategory);
  //
  //             const dietaryMatch =
  //                 activeDietaries.length === 0 ||
  //                 activeDietaries.every((diet) => {
  //                     return dish.dietary.some((dishDiet) => dishDiet.dietary === diet);
  //                 });
  //             return categoryMatch && dietaryMatch;
  //         });
  //     } catch (e) {
  //         console.error(e);
  //         return [];
  //     }
  // };

  // const dishesMap = {
  //     'New': pastaDish,
  //     'Antipasta': antipastaDish,
  //     'Pizza': pizzaDish,
  //     'Pasta': pastaDish,
  //     'Insalata': insalataDish,
  //     'Entree': entreeDish
  // };

  // @ts-ignore
  // const filteredDishes = dishesMap[activeCategory] || initialPastaDishes || [];

  const renderItem = (item: DishInMenuType, isFirstDish: boolean) => {
    return (
      <div onClick={() => handleClickCard(item.id)} className={styles.card}>
        <img src={item?.image?.url} alt={item?.name} className={styles.image} />
        {((menu?.topChoiceEnabled && item?.isTopChoice) || (menu?.recommendedEnabled && item?.isRecommended)) && (
          <div className={styles.badgesContainer}>
            {menu?.topChoiceEnabled && item?.isTopChoice && (
              <div className={styles.topChoiceBadgeWrapper}>
                <TopChoiceBadge
                  isTopChoice={item?.isTopChoice}
                  customBadgeUrl={
                    menu?.topChoiceIconType === "custom" && menu?.topChoiceCustomIcon?.url
                      ? menu.topChoiceCustomIcon.url
                      : null
                  }
                />
              </div>
            )}
            {menu?.recommendedEnabled && item?.isRecommended && (
              <div className={styles.recommendedBadgeWrapper}>
                <RecommendedBadge
                  isRecommended={item?.isRecommended}
                  customBadgeUrl={
                    menu?.recommendedIconType === "custom" && menu?.recommendedCustomIcon?.url
                      ? menu.recommendedCustomIcon.url
                      : null
                  }
                />
              </div>
            )}
          </div>
        )}
        {isFirstDish && (
          <div className={styles.overlay}>
            <span className={styles.overlayText}>{t("tapForDetails")}</span>
          </div>
        )}
        <div className={styles.cardContainer}>
          <div className={styles.headerContainer}>
            <span className={styles.headerText}>{localizeDish(item, locale).name}</span>
            {/*<div className={styles.dietaries}>*/}
            {/*    {item?.dietary?.map((dietary: DietaryOption, index: number) => {*/}
            {/*        return <Indicator*/}
            {/*            key={index}*/}
            {/*            name={IndicatorEnum.MENU}*/}
            {/*            dietary={dietary.dietary}*/}
            {/*        />*/}
            {/*    })}*/}
            {/*</div>*/}
          </div>
          <div className={styles.containerBottom}>
            <Indicator
              name={IndicatorEnum.PRICE}
              text={formatPrice(item.price)}
            />
            {orderingEnabled && (
              <div
                className={styles.quantitySlot}
                onClick={(event) => event.stopPropagation()}
              >
                <QuantityControl dish={item} variant="card" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {/*<Notification/>*/}
      <div className={styles.container}>
        <HeaderMenu />
        <div className={styles.controlBlock}>
          {/*<div onClick={() => setModalVisible(true)} className={styles.filterButton}>*/}
          {/*    <>*/}
          {/*        /!*<Filter width={vw(16)} height={vw(16)}/>*!/*/}
          {/*        <img src={Filter} alt={'Filter'}/>*/}
          {/*        <div*/}
          {/*            style={{*/}
          {/*                color: $white,*/}
          {/*                fontSize: vw(12)*/}
          {/*            }}>Filters*/}
          {/*        </div>*/}
          {/*        /!*<Chevron width={vw(12)} height={vw(12)}/>*!/*/}
          {/*        <img alt={'Chevron'} src={Chevron}/>*/}
          {/*    </>*/}
          {/*</div>*/}
        </div>
        <div className={styles.content}>
          {loading || categoryLoading || !activeCategory ? (
            <div className={styles.loader}>
              <Loader />
            </div>
          ) : (
            categorizedDishes[activeCategory]?.map(
              (dish: DishInMenuType, index: number) => (
                <React.Fragment key={index}>
                  {renderItem(dish, index === 0 && !isDishClicked)}
                </React.Fragment>
              )
            )
          )}
        </div>
      </div>
      {/*<FilterModal modalVisible={modalVisible} setModalVisible={setModalVisible}/>*/}
    </>
  );
};
